"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCollissionResolver = void 0;
var defaultCollissionResolver = function (elementName) { return "_" + elementName; };
exports.defaultCollissionResolver = defaultCollissionResolver;
//# sourceMappingURL=default-collision-resolver.js.map